import JSONAPISerializer from '@ember-data/serializer/json-api';
import { DateTime } from 'scaleflow/utils/date-time';

const isISODateString = (dateString) => {
  // ISO 8601 regex
  const isoRegex =
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(\.\d+)?(Z|([+-]\d{2}:\d{2}))?$|^(\d{4})-(\d{2})-(\d{2})$/;

  // Test against the regex
  return isoRegex.test(dateString);
};

// e.g. "Mon Dec 04 2023 00:00:00 GMT+0100" -> "2023-12-04T00:00:00.000+01:00"
const toIsoString = (value) => {
  if (!value) throw new Error('Param cannot be empty');
  const date = DateTime.from(value);
  if (!date.isValid())
    throw new Error('Invalid param: Could not form date from provided param');
  return date.toISOString(true);
};

export default class RoadmapSerializer extends JSONAPISerializer {
  keyForAttribute(attr) {
    return attr;
  }

  serialize() {
    let json = super.serialize(...arguments);
    const start_date = json.data?.attributes?.start_date;
    if (!isISODateString(start_date))
      json.data.attributes.start_date = toIsoString(start_date);
    const end_date = json.data?.attributes?.end_date;
    if (!isISODateString(end_date))
      json.data.attributes.end_date = toIsoString(end_date);
    return json;
  }
}
